import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ReactSelectMaterialUi from 'react-select-material-ui';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name
  })),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    addConfirm,
    openAddProgress,
    progressOkAction,
    loading,
    resultMessage,
    isLanguage,
    setIsLanguage,
    shopName,
    groupName,
    previewImage
  }) => {
    let { childFoodName, childFoodDescription } = addConfirm;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = addConfirm.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        ({ childFoodName, childFoodDescription } = languageData.params);
      } else {
        childFoodName = 'Google Translate で自動的に翻訳されるもの';
        childFoodDescription = 'Google Translate で自動的に翻訳されるもの';
      }
    }

    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー登録確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗名</TableCell>
              <TableCell className={classes.tableCellData}>
                {shopName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                グループ名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {groupName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                メニュー名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {childFoodName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>説明</TableCell>
              <TableCell className={classes.tableCellData}>
                {childFoodDescription}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>画像</TableCell>
              <TableCell className={classes.tableCellData}>
                <ImagePreview previewImage={previewImage} />
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
        <ProgressDialog
          openProgress={openAddProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
